import { Col, Form, Row, Select } from "antd"
import { type FormInstance } from "antd/es/form/hooks/useForm"
import React from "react"

import { useAppSelector } from "../../../../../../hooks/use-app-selector.ts"
import { PROJECT_ENTITY_CATEGORIES } from "../../../../ProjectViewPage/constants/project-entity-category.ts"
import type { ProjectFormData } from "../../project-form-data.ts"

interface ProjectTypeCategoryFieldsProps {
  form: FormInstance<ProjectFormData>
  assignedTypeIds: string[]
  typeNames: Record<string, string>
}

export function ProjectTypeCategoryFields({
  form,
  assignedTypeIds,
  typeNames
}: ProjectTypeCategoryFieldsProps) {
  const selectedIds = Form.useWatch("project_type", form)
  const categories = useAppSelector(
    (state) => state?.projects?.filterOptions?.category || []
  )

  const addedIds = (selectedIds || []).filter(
    (id) => !assignedTypeIds.includes(id)
  )

  if (!addedIds.length) return null

  return (
    <Row gutter={16}>
      {addedIds.map((id) => (
        <Col xs={24} sm={12} key={id}>
          <Form.Item
            label={`Type for ${typeNames?.[id] || "new project type"}`}
            name={["project_type_categories", id]}
            initialValue={PROJECT_ENTITY_CATEGORIES.STANDARD}
            rules={[{ required: true, message: "Please select type" }]}
          >
            <Select
              className={"w-full"}
              placeholder={"Select a type"}
              options={categories}
            />
          </Form.Item>
        </Col>
      ))}
    </Row>
  )
}
